module.exports = __webpack_public_path__ + "static/cabina-conductor---tablero-de-control-3328ad40657501cc1884431eee2c63de.jpg";